<template>
  <Modal appear @close="close">
    <template slot="title">
      検索順位を定点観測するキーワードを登録する
    </template>
    <template slot="lead">
      キーワードとURLを登録しましょう
    </template>
    <template slot="content">
      <FormAddSeedKeyword
        :items="items"
        :keyword="keyword"
        :project="project"
        :url="url"
        :isFocus="true"
        :isLoading="isLoading"
        @add="add"
      />
    </template>
  </Modal>
</template>

<script>
import FormAddSeedKeyword from '@/components/config/FormAddSeedKeyword';
import Modal from '@/components/Modal';

export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    keyword: {
      type: String,
      required: false
    },
    project: {
      type: Object,
      required: true
    },
    url: {
      type: String,
      required: false
    },
    isFocus: {
      type: Boolean,
      required: false
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  components: {
    FormAddSeedKeyword,
    Modal
  },
  methods: {
    add(keywords) {
      this.$emit('add', keywords);
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>
